import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextButton from 'components/Luxkit/Button/TextButton'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import Divider from 'components/Luxkit/Divider'
import Caption from 'components/Luxkit/Typography/Caption'
import TextLink from 'components/Luxkit/TextLink'
import { Trans } from 'react-i18next'

const BorderedContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
  border-top: 0;
  padding: ${rem(12)} ${rem(16)} ${rem(24)};
  min-width: ${rem(320)};
`

const PackagePriceDetailsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  min-height: ${rem(40)};
`

interface Props {
  pkg: App.Package;
  totalValue: number;
  priceDifference?: number;
  showDetailsToggle: boolean;
  onViewDetails?: () => void;
  onUpgrade?: () => void;
  onNoThanks?: () => void;
}

function LePackageUpgradeColumnFooter({
  pkg,
  totalValue,
  priceDifference,
  showDetailsToggle,
  onViewDetails,
  onUpgrade,
  onNoThanks,
}: Props) {
  return (
    <BorderedContainer>
      <Group direction="vertical" gap={8}>
        {showDetailsToggle && (
          <TextLink onClick={onViewDetails}>
            <Caption variant="medium" weight="bold">
              View more details
            </Caption>
          </TextLink>
        )}

        <Divider kind="primary" />

        <PackagePriceDetailsFooter>
          <Group direction="vertical">
            {onUpgrade && priceDifference && (
              <Heading variant="heading6" colour="neutral-one">
                + <FormatCurrency value={priceDifference}/>
              </Heading>
            )}
            <BodyText variant="small" colour="neutral-three">
              <Trans
                i18nKey="currencyTotalForNights"
                ns="common"
                // eslint-disable-next-line react/jsx-key
                components={[<FormatCurrency value={totalValue} />]}
                values={{
                  count: pkg.duration,
                }}
              />
            </BodyText>
          </Group>
          {onUpgrade && <TextButton kind="primary" onClick={onUpgrade}>Upgrade</TextButton>}
          {onNoThanks && <TextButton kind="secondary" onClick={onNoThanks}>Keep package</TextButton>}
        </PackagePriceDetailsFooter>
      </Group>
    </BorderedContainer>
  )
}

export default LePackageUpgradeColumnFooter
